export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PEG_PAGE = 10;
export const KEY = '0f07f615-00c0-44ed-9a4e-03a0fae63599';
export const MODAL_CLOSE_SEC = 2.5;
